module.exports = __webpack_public_path__ + "img/icon18.c60ff5d5.png";